import React, { useEffect, useState, useCallback, useMemo } from 'react';
import Select from 'react-select';
import RequisitionGrid from './requisitionGrid';
import AuthorizationGrid from './authorization';
import MessageGrid from './messageGrid';
import ApiService from '../../services/apiService';
import { toast } from 'react-toastify';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { clearRows } from '../../../Redux/actions/rowActions';
import { ClipLoader } from 'react-spinners';
import { getUserId, getName, getUserName, getCompany } from '../../../Redux/selecters';
import { useSelector } from 'react-redux';
import { FaAngleLeft } from "react-icons/fa6";
import { RiRefreshLine } from "react-icons/ri";
import { FaSave } from "react-icons/fa";
import Attachment from '../Attachment/attachment';
import Modal from 'react-bootstrap/Modal';
import WindowedSelect from "react-windowed-select";

const createEmptyRow = () => ({
    id: Date.now() + Math.random(),
    file: null,
    fileName: "",
    remarks: "",
});
const REPORT_URL = process.env.REACT_APP_REPORTS_URL

const PurchaseRequisition = () => {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const apiService = new ApiService();
    // const { SelectedCurrency } = useCurrency();
    const userId = useSelector(getUserId);
    const userName = useSelector(getUserName);
    const name = useSelector(getName);
    const Company = useSelector(getCompany);
    const [activeTab, setActiveTab] = useState(0);
    const [itemData, setitemData] = useState()
    const [gridVisibility, setGridVisibility] = useState([true, false, false]);
    const [messageData, setMessageData] = useState([]);
    const [department, setDepartment] = useState([]);
    const [cost1, setCost1] = useState([]);
    const [cost2, setCost2] = useState([]);
    const [cost3, setCost3] = useState([]);
    const [cost4, setCost4] = useState([]);
    const [Location, setLocation] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState([]);
    const [authorizationData, setAuthorizationData] = useState([]);
    const [requisitionData, setRequisitionData] = useState([]);
    const [requisitionList, setRecositionList] = useState([]);
    const [SupplierTab, setSupplierTab] = useState(true);
    const [CostTab, setCostTab] = useState(true);
    const [usersDetails, setUser] = useState([]);
    const [loader, setLoader] = useState(false);
    const [deliveryPoint, setDeliveryPoint] = useState();
    const [itemtype, setItemtype] = useState({ label: "Inventory", value: "Inventory" });
    const [selLocation, setSelLocation] = useState();
    const [contactPerson, setContactPerson] = useState();
    const [ReqNo, setReqNo] = useState([]);
    const [SelectedCurrency, setSelectedCurency] = useState([]);
    const currentDatetimeUTC = new Date().toISOString().slice(0, 16);
    const [docModal, setDocModal] = useState(false);
    const onOpenModal = () => setDocModal(true);
    const onCloseModal = () => setDocModal(false);

    // Attachment
    const [attachmentModal, setAttachmentModal] = useState(false);
    const [previewModal, setPreviewModal] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const [attachments, setAttachments] = useState([createEmptyRow()]);
    const openModal = () => setAttachmentModal(true);
    const closeModal = () => setAttachmentModal(false);

    const getCurrentLocalDatetime = () => {
        const localDate = new Date();
        const offset = localDate.getTimezoneOffset() * 60000;
        const localISOTime = new Date(localDate - offset).toISOString().slice(0, 16);
        return localISOTime;
    };
    const [formData, setFormData] = useState({
        recordId: "",
        requisitionNo: "",
        itemType: "",
        copyRequest: "",
        quatotionNo: "",
        remarks: "",
        requestor: userName || "",
        requisitionDate: getCurrentLocalDatetime(),
        deliveryDate: getCurrentLocalDatetime(),
        currencyCode: "",
        exchangeRate: "",
        costCenter1: "",
        costCenter2: "",
        costCenter3: "",
        costCenter4: "",
        location: "",
        contactPerson: "",
        contatNo: "",
        taskCode: "",
        subcatname: "",
    });
    useEffect(() => {
        getCurrency()
        getLocation()
    }, [])

    const getCurrency = async () => {

        const currencylist = JSON.parse(localStorage.getItem('currencylist')) || [];
        const newDefaultCurrency = currencylist?.find((comp) => comp.isDefault === true);
        setSelectedCurency({ label: newDefaultCurrency.code, value: newDefaultCurrency });
        let docParam = `?TypeOfDoc=Req&DocId=Requisition`
        let DocId = await apiService.getApiParamater('GET_DOC_ID', docParam)
        setReqNo(DocId?.data.result[0].docId);
        const params = new URLSearchParams();
        params.append('DocNo', '');
        params.append('DocumentType', "Purchase Requisition");
        const response = await apiService.getApiParamater('GET_DOC_STATUS_EDIT', `?${params.toString()}`);
        setUser(response.data.result);
    }
    const GenerateNumber = async () => {
        let docParam = `?TypeOfDoc=Req&DocId=Requisition`
        let DocId = await apiService.getApiParamater('GET_DOC_ID', docParam)
        setReqNo(DocId?.data.result[0].docId);
        onCloseModal()
    }
    const getLocation = async () => {
        let param = `?Exp3=1`
        let res = await apiService.getApiParamater('GET_WAREHOUSE_MASTER', param)
        setLocation(res.data.result);

        let DepRes = await apiService.getApiParamater('GET_DEPARTMENT_MASTER', param)
        setDepartment([{ value: null, description: 'None' }, ...DepRes.data.result]);

        let cost1 = await apiService.get('GET_COST_ONE')
        setCost1([{ value: null, description: 'None' }, ...cost1.data.result]);

        // let cost2 = await apiService.get('GET_COST_TWO')
        // setCost2([{ value: null, description: 'None' }, ...cost2.data.result]);

        let cost3 = await apiService.get('GET_COST_THREE')
        setCost3([{ value: null, description: 'None' }, ...cost3.data.result]);

        let cost4 = await apiService.get('GET_COST_FOUR')
        setCost4([{ value: null, description: 'None' }, ...cost4.data.result]);
        let dropParam = `?dropdownTypes=CopyFromRequisitionNos`
        let dropRes = await apiService.getApiParamater('GET_DIRECT_PO', dropParam)
        setRecositionList(dropRes?.data?.dropdowns?.CopyFromRequisitionNos.reverse())
    }
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    };
    const handleMessage = (data) => {
        setMessageData(data);
        console.log(data, 'reqData')
    };
    const handleRequisitionData = (data) => {
        setRequisitionData(data);
        console.log(data, 'reqData')
    };
    const handleAuthorization = (data) => {
        setAuthorizationData(data);
        console.log(data, 'reqData')
    };
    const requisitionOptions = useMemo(() => {
        return requisitionList?.map((item) => ({
            value: item.value,
            label: item.text,
        }));
    }, [requisitionList]);
    const staticOptions = [];
    const itemType = [
        { value: 'Inventory', label: 'Inventory' },
        { value: 'FixedAsset', label: 'Fixed Asset' },
        { value: 'Services', label: 'Services' },
    ];
    const totalAmount = requisitionData.reduce((sum, row) => sum + (row?.qty * row.baseAmount || 0), 0);
    const CreatePR = async () => {
        setLoader(true)
        if (!selectedLocation?.value?.description) {
            toast.warning("Select location");
            setLoader(false)
            return;
        }
        for (const item of requisitionData) {
            if (!item.itemNo) {
                toast.warning(`Please Select Item`);
                setLoader(false);
                return;
            } else if (!item.itemDescription) {
                toast.warning(`Please Select Item`);
                setLoader(false);
                return;
            } else if (!item.qty) {
                toast.warning(`Please enter ${item.itemDescription} quantity`);
                setLoader(false);
                return;
            } else if (item.qty === "0") {
                toast.warning(`${item.itemDescription} quantity must be greater then 0`);
                setLoader(false);
                return;
            }
        }
        try {
            const prDetailsData = requisitionData?.map(item => ({
                requisitionNo: ReqNo.toString(),
                srno: parseInt(item.srno),
                itemCode: item?.itemNo.toString(),
                itemDescription: item.itemDescription,
                uom: item.uom,
                qty: parseFloat(item.qty),
                baseUOM: item?.uom,
                baseQty: parseFloat(item.qty),
                specification: item.specification,
                convValue: 1,
                unitPrice: Number(item.baseAmount).toFixed(SelectedCurrency?.value?.exp1 || 2),
                amount: Number(item.amount).toFixed(SelectedCurrency?.value?.exp1 || 2),
                baseAmount: Number(item.amount).toFixed(SelectedCurrency?.value?.exp1 || 2)
            }));
            const currentDatetimeUTC = new Date().toISOString();
            const userData = {
                type: itemtype?.label,
                requisitionNo: ReqNo,
                reqType: "Purchase Request",
                contractNo: formData?.quatotionNo,
                description: formData?.remarks,
                requestor: formData?.requestor,
                requisitionDate: currentDatetimeUTC,
                deliveryDate: formData.deliveryDate,
                currencyCode: SelectedCurrency?.code,
                exchangeRate: SelectedCurrency?.value?.conversionRate,
                department: selectedDepartment?.value?.description,
                remarks: formData?.remarks,
                modifiedBy: userName || name,
                approvalUser: selectedLocation?.label,
                costCenter1: formData.costCenter1?.label,
                costCenter2: formData.costCenter2?.label,
                costCenter3: formData.costCenter3?.label,
                costCenter4: formData.costCenter4?.label,
                deliveryPoint: deliveryPoint || "",
                location: selLocation,
                contactPerson: contactPerson,
                contatNo: formData?.contatNo,
                projectCode: formData?.taskCode,
                prDetails: prDetailsData,
                status: 0,
                baseAmount: Number(totalAmount).toFixed(SelectedCurrency?.value?.exp1 || 2),
                amount: Number(totalAmount).toFixed(SelectedCurrency?.value?.exp1 || 2),
            };
            const response = await apiService.post("CREATE_PR", userData);

            if (response?.data?.statusCode === 201 || response?.data?.statusCode === 200) {

                const docNumber = response?.data?.result?.requisitionNo
                const userData2 = {
                    docType: "Purchase Requisition",
                    docId: ReqNo ? ReqNo.toString() : ReqNo,
                    department: "IT",
                    company: Company?.selectedCompany?.companyNo,
                    userCode: userId,
                    userName: userName,
                };
                const docBody = {
                    docId: "Requisition",
                    typeOfDoc: "Req",
                };
                const docRes = await apiService.put("UPDATE_DOC_ID", docBody);
                if (attachments) {
                    handleUpload()
                }
                const response2 = await apiService.post("CREATE_DOC_AUTHORIZATION", userData2);
                const paramsGet = new URLSearchParams();
                paramsGet.append('docType', "Purchase Requisition");
                paramsGet.append('docId', ReqNo);
                paramsGet.append('srno', 1);
                const response3 = await apiService.getApiParamater('GET_DOC_APPROVAL_USER', `?${paramsGet.toString()}`);
                // if (response3?.data?.result.length > 0) {
                //     const toEmails = response3?.data?.result?.map(user => user.userEmail);
                //     const emailbody = {
                //         toEmails: toEmails,
                //         subject: "Purchase Requisition",
                //         body: "",
                //         docNo: ReqNo,
                //         srNo: 1,
                //         docType: "Requisition"
                //     };
                //     const emailres = await apiService.post("DOC_APPROVAL_EMAIL_POST", emailbody);
                // }
                const token = localStorage.getItem("Token");
                const DB = localStorage.getItem("DataBase")
                if (!token) {
                    alert("Auth token is missing! Unable to proceed.");
                    return;
                }
                const popupWidth = 1000;
                const popupHeight = 600;
                const popupLeft = (window.screen.width - popupWidth) / 2;
                const popupTop = (window.screen.height - popupHeight) / 2;
                const popup = window.open(
                    "",
                    "ReportPopup",
                    `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
                );

                if (popup) {
                    const form = document.createElement("form");
                    form.method = "POST";
                    form.action =
                        REPORT_URL;
                    form.target = "ReportPopup";

                    const inputs = [
                        { name: "authToken", value: token },
                        { name: "_db", value: DB },
                        { name: "reportName", value: "PurchaseRequisition" },
                        { name: "voucherNo", value: ReqNo },
                    ];

                    inputs.forEach(({ name, value }) => {
                        const input = document.createElement("input");
                        input.type = "hidden";
                        input.name = name;
                        input.value = value;
                        form.appendChild(input);
                    });

                    document.body.appendChild(form);
                    form.submit();
                    document.body.removeChild(form);
                }
                toast.success(`${ReqNo} Created successfully`);
                handleReset()
                navigate("/Inventory/Requisition/Listing")
            } else if (response?.data?.statusCode === 208) {
                setLoader(false)
                onOpenModal()
            }
            setLoader(false)
        } catch (error) {
            setLoader(false)
            console.error("Error Creating PR:", error);
        }
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if ((name === 'contatNo') && value.length > 16) {
            // toast?.warning("Enter contact no less then 16")
            return;
        } else if (name === 'requisitionDate' || name === 'deliveryDate') {
            const dateParts = e.target.value.split("-");
            if (dateParts[0].length > 4) {
                return;
            }
        } else if ((name === "contatNo") && value < 0) {
            return;
        } else if (name === 'deliveryPoint') {
            setDeliveryPoint(e.target.value);
            return;
        } else if (name === 'location') {
            setSelLocation(e.target.value);
            return;
        } else if (name === 'contactPerson') {
            setContactPerson(e.target.value);
            return;
        } else {
            setFormData({ ...formData, [e.target.name]: e.target.value });
        }
    };
    const handleDropdownChange = async (name, value) => {

        if (name === "selectedDepartment") {
            setSelectedDepartment(value)
        } else if (name === "selectedLocation") {
            const params = new URLSearchParams();
            params.append('Commontext', value?.label);
            params.append('Action', "GetPropertyByStoreForReq");
            const res = await apiService.getApiParamater('GET_REQ_COMMON', `?${params.toString()}`);
            let cost = res?.data?.result?.data

            setSelectedLocation(value)
            if (cost?.Location) {
                setFormData({ ...formData, costCenter1: { label: cost?.Location || "", value: cost?.Location || "" } });
            }
        } else if (name === "itemType") {
            setItemtype(value)
        } else if (name === "copyRequest") {
            if (value?.label) {
                let param = `?Id=${value?.label}`
                const response = await apiService.getApiParamater('GET_PR', param);
                let data = response?.data?.result[0] || null
                setitemData(data)
            }
            setFormData({ ...formData, [name]: value });
        } else if (name === "costCenter1") {
            let param = `?DropdownFor=GetUnitsByPropId&CascadValue=${value?.value?.exp1}`
            const response = await apiService.getApiParamater('GET_PR_CASCAD', param);
            let data = response?.data?.items || []
            setCost2([{ value: null, text: 'None' }, ...data]);
            setFormData({ ...formData, [name]: value, costCenter2: null });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    }
    const handleReset = () => {
        setLoader(false)
        setFormData({
            itemType: "",
            quatotionNo: "",
            remarks: "",
            requestor: "",
            currencyCode: "",
            department: "",
            costCenter1: "",
            costCenter2: "",
            costCenter3: "",
            costCenter4: "",
            deliveryPoint: "",
            contatNo: "",
            taskCode: "",
        });
        dispatch(clearRows());
        setSelectedDepartment([])
        setSelectedLocation([])
    }
    const preventNegativeSign = (e) => {
        if (e.key === "-") {
            e.preventDefault();
        }
    };
    const handleBackClick = () => {
        window.history.back();
    };
    // Attachment Functions
    const handleFileSelect = useCallback((file, id) => {
        setAttachments((prev) => {
            const updated = prev.map((row) =>
                row.id === id ? { ...row, file, fileName: file.name } : row
            );
            return [...updated, createEmptyRow()];
        });
    }, []);
    const handleRemarkChange = (id, value) => {
        setAttachments((prev) =>
            prev.map((row) =>
                row.id === id ? { ...row, remarks: value } : row
            )
        );
    };
    const handleDelete = (id) => {
        setAttachments((prev) => prev.filter((row) => row.id !== id));
    };
    const handleView = (file) => {
        if (!file) return;

        setPreviewImage(URL.createObjectURL(file));
        setPreviewModal(true);
    };
    const handleUpload = async () => {
        const formData = new FormData();

        attachments.forEach(({ file }) => {
            if (file instanceof File) {
                formData.append('Images', file, file.name);
            }
        });

        const response = await apiService.postMultiPart('UPLOAD_FILE', formData);

        if (response?.data?.statusCode === 201 && response?.data?.isSuccessful) {
            const uploadedFileNames = response.data.result.split(',');

            const payload = {
                docFilesDtos: attachments
                    .filter((a) => a.file)
                    .map((a, index) => ({
                        srno: index + 1,
                        docNo: ReqNo,
                        docType: 'Requisition',
                        fileName: uploadedFileNames[index]?.trim(),
                        remarks: a.remarks || '',
                    })),
            };

            await apiService.post('CREATE_ATTACHMENT', payload);
            return;
        }
    };
    return (
        <div className='p-4'>
            <div className='d-flex justify-contant-between '>
                <h5 className='col mainInvHead'>Purchase Requisition</h5>
                <div className='d-flex justify-content-end gap-1'>
                    <div className='col center'>
                        <>{loader === true ?
                            <button className='mainbtn ' type="submit"><ClipLoader color="#ffffff" size={25} /></button> :
                            <button className='mainbtn ' onClick={CreatePR} type="submit">
                                <FaSave className='center mt-1 mx-2' /> <div>Save</div>
                            </button>
                        }
                        </>
                    </div>
                    <button className='mainbtnRed' onClick={() => handleReset()}><RiRefreshLine className='center mt-1 mx-2' /><div>Reset</div></button>
                    <button onClick={handleBackClick} className='mainbtnSecondary'><FaAngleLeft className='center mt-1 mx-2' /><div>Back</div></button>
                </div>
            </div>
            <div className="cost-center-section mb-2">
                <div className="d-flex mt-3 cursor-pointer slide-header gap-4"
                    onClick={() => setSupplierTab(!SupplierTab)}>
                    <div className='h6 pt-1'>Requisition Details</div>
                </div>
                <div className={`slide-content ${SupplierTab ? 'open' : 'closed'}`}>
                    <div className="border-box2 p-3">
                        <div className="form-group row pb-3">
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="ReqNo" className="form-label  pt-2 start">Requisition No</label>
                                <input
                                    className="form-Input w-100"
                                    disabled
                                    value={ReqNo}
                                    name="ReqNo"
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="deliveryDate" className="form-label  pt-2 start">Delivery Date</label>
                                <input
                                    className='form-Input w-100'
                                    type='datetime-local'
                                    value={formData.deliveryDate}
                                    name="deliveryDate"
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="deliveryDate" className="form-label  pt-2 start">Store *</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    value={selectedLocation}
                                    onChange={(selectedOption) => handleDropdownChange('selectedLocation', selectedOption)}
                                    options={Location?.map((loc) => ({ value: loc, label: loc?.description }))}
                                    className="w-100 p-0"
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="requisitionDate" className="form-label  pt-2 start">Date </label>
                                <input
                                    className='form-Input w-100'
                                    type='datetime-local' disabled
                                    value={formData.requisitionDate}
                                    name="requisitionDate"
                                />
                            </div>
                            {/* <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="deliveryPoint" className="form-label  pt-2 start">Delivery Point</label>
                                    <input
                                        type="text"
                                        className="form-Input w-100"
                                        id="deliveryPoint"
                                        value={deliveryPoint}
                                        onChange={handleInputChange}
                                        name="deliveryPoint"
                                    />
                            </div> */}
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="location" className="form-label  pt-2 start">Location</label>
                                <input
                                    type="text"
                                    className="form-Input w-100"
                                    id="location"
                                    value={selLocation}
                                    onChange={handleInputChange}
                                    name="location"
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Copy Request</label>
                                <WindowedSelect
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5" : null,
                                            color: "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000",
                                            },
                                        }),
                                    }}
                                    className="w-100 p-0"
                                    menuPlacement="auto"
                                    isClearable
                                    menuShouldScrollIntoView={false}
                                    value={formData?.copyRequest}
                                    options={requisitionOptions}
                                    onChange={(selectedOption) =>
                                        handleDropdownChange("copyRequest", selectedOption)
                                    }
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Currency</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-100 p-0"
                                    isSearchable={false}
                                    menuPlacement="auto" isDisabled
                                    menuShouldScrollIntoView={false}
                                    value={SelectedCurrency}
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="contactPerson" className="form-label  pt-2 start">Contact Person</label>
                                <input
                                    type="text"
                                    className="form-Input w-100"
                                    id="contactPerson"
                                    value={contactPerson}
                                    onChange={handleInputChange}
                                    name="contactPerson"
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Quotation No</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    className="w-100 p-0"
                                    options={staticOptions}
                                    onChange={(selectedOption) => handleInputChange('inventoryAccountCode', selectedOption)}
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="exchangeRate" className="form-label  pt-2 start">Exchange Rate</label>
                                <input
                                    type="text"
                                    className="form-Input w-100"
                                    disabled
                                    onWheel={(e) => e.target.blur()}
                                    id="exchangeRate"
                                    value={SelectedCurrency?.value?.conversionRate}
                                    onChange={handleInputChange}
                                    name="exchangeRate"
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="contatNo" className="form-label  pt-2 start">Contact No</label>
                                <input
                                    type="number"
                                    className="form-Input w-100"
                                    id="contatNo"
                                    onWheel={(e) => e.target.blur()}
                                    value={formData.contatNo}
                                    onChange={handleInputChange}
                                    onKeyDown={preventNegativeSign}
                                    name="contatNo"
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="requestor" className="form-label  pt-2 start">Requester</label>
                                <input
                                    type="text"
                                    className="form-Input w-100"
                                    id="requestor"
                                    value={formData.requestor}
                                    onChange={handleInputChange}
                                    name="requestor"

                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Item Type</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    value={itemtype}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-100 p-0"
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    options={itemType}
                                    onChange={(selectedOption) => handleDropdownChange('itemType', selectedOption)}
                                />
                            </div>
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="subcatname" className="form-label  pt-2 start">Remarks</label>
                                <input
                                    name="remarks"
                                    type='text'
                                    className="form-Input w-100"
                                    id="subcatname"
                                    value={formData.remarks}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="selectedDepartment" className="form-label  pt-2 start">Department</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-100 p-0"
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    value={selectedDepartment}
                                    options={department?.map((dep) => ({ value: dep, label: dep?.description }))}
                                    onChange={(selectedOption) => handleDropdownChange('selectedDepartment', selectedOption)}
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="department" className="form-label  pt-2 start">Task Code</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-100 p-0"
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    defaultValue={formData.taskCode}
                                // onChange={handleDepChange}
                                // options={taskCode?.map((dep) => ({ value: dep, label: dep?.name }))}
                                />
                            </div>
                            <div className='col-1 px-5 mx-3'></div>
                            <div className="col-2 brderbox center" onClick={() => openModal()} >
                                {'Attachment'}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section mb-2">
                <div className="d-flex mt-3 cursor-pointer slide-header gap-4"
                    onClick={() => setCostTab(!CostTab)}>
                    <div className='h6 pt-1'>Cost Center</div>
                </div>
                <div className={`slide-content ${CostTab ? 'open' : 'closed'}`}>
                    <div className="border-box2 p-3">
                        <div className="form-group row justify-content-between">
                            <div className="col-4   d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Property</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-100 p-0"
                                    value={formData.costCenter1}
                                    options={cost1?.map((sup) => ({ value: sup, label: sup?.description }))}
                                    onChange={(selectedOption) => handleDropdownChange('costCenter1', selectedOption)}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Unit</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    className="w-100 p-0"
                                    value={formData.costCenter2}
                                    onChange={(selectedOption) => handleDropdownChange('costCenter2', selectedOption)}
                                    options={cost2?.map((sup) => ({ value: sup, label: sup?.text }))}
                                />
                            </div>
                            <div className="col-4  d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Cost Center 3</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    className="w-100 p-0"
                                    value={formData.costCenter3}
                                    onChange={(selectedOption) => handleDropdownChange('costCenter3', selectedOption)}
                                    options={cost3?.map((sup) => ({ value: sup, label: sup?.description }))}
                                />
                            </div>
                            <div className="col-4 mt-2 d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-2 start">Cost Center 4</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    className="w-100 p-0"
                                    value={formData.costCenter4}
                                    onChange={(selectedOption) => handleDropdownChange('costCenter4', selectedOption)}
                                    options={cost4?.map((sup) => ({ value: sup, label: sup?.description }))}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`cost-center-section`}>
                <div className="mt-3 cursor-pointer slide-header">
                    <div className="nav nav-pills overslid d-flex gap-4">
                        {/* Nav tabs */}
                        <div
                            className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(0)}
                        >
                            Requisition
                        </div>
                        <div
                            className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(1)}
                        >
                            Authorization
                        </div>
                        <div
                            className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(2)}
                        >
                            Message
                        </div>
                    </div>
                </div>
            </div>
            <div className={`slide-content open`}>
                <div className={`grid-1 border-box2 p-3`}>
                    {gridVisibility[0] && (
                        <RequisitionGrid onRequisitionData={handleRequisitionData} itemData={itemData} selectedLocation={selectedLocation}
                            precision={SelectedCurrency?.value?.exp1 || 3} itemtype={itemtype} formData={formData} />
                    )}
                    {gridVisibility[1] && (
                        <AuthorizationGrid
                            handleAuthorization={handleAuthorization}
                            usersDetails={usersDetails}
                            setUser={setUser}
                            itemData={itemData}
                        />
                    )}
                    {gridVisibility[2] && (
                        <div className="grid-3 border">
                            <MessageGrid handleMessage={handleMessage} />
                        </div>
                    )}
                </div>
            </div>
            <div>
                <Attachment
                    documentNo={ReqNo}
                    open={attachmentModal}
                    onClose={closeModal}
                    rows={attachments}
                    onFileSelect={handleFileSelect}
                    onRemarkChange={handleRemarkChange}
                    onDelete={handleDelete}
                    onSave={handleUpload}
                />
            </div>
            <Modal size="md"
                show={docModal} onHide={() => setDocModal(false)}
                backdrop="static"
                contentLabel='Doc Id Modal'
            >
                <Modal.Header closeButton>
                    <Modal.Title className="center">Requisition Number</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="text-danger">
                        The requisition number already exists. Click "Generate" to assign a new number.
                    </p>
                </Modal.Body>
                <Modal.Footer className='end p-3'>
                    <button className='mainbtnGry' onClick={onCloseModal}>Cancel</button>
                    <button className='mainbtnRed' onClick={GenerateNumber}>Generate</button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default PurchaseRequisition